module.exports = __webpack_public_path__ + "img/1d54f57.jpg";